<template>
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :title="$t('Printers')"
          :text="$t('printers-info-text')"
          :btnText="$t('add_printer')"
          @action="openNewPopup" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table" :key="updateList">
          <li
            @click="openEditPopup(item.id)"
            class="list-table-item"
            v-for="(item, index) in get_printers.items" :key="`item-${index}`">
            <div class="table-cell small" :key="`item-icon-${index}`">
              <div class="list-icon-block">
                <div class="status-indicator" :class="item.is_online == 1 ? 'active' : 'inactive'"></div>
                <Icon
                  :circle=true
                  :name="parseInt(item.type) === 1 ? 'printerLabel' : 'printer'"
                  :size="parseInt(item.type) === 1 ? '18' : '22'" />
              </div>
            </div>
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.name}` }}
              </span>
                <span class="additional-info">
                  {{ get_printers.entity.type[item.type] }}
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Popup
      v-if="openPopup"
      :popupSmall=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      :showConfirmButton="!deletePrinter"
      :showDeleteButton="deletePrinter"
      @cancel="togglePopup"
      @deleteAction="deletePrinterAction"
      @confirm="submitForm">
      <template v-slot:header>
        <h2 v-if="!isEdit">{{ $t('add_printer') }}</h2>
        <h2 v-if="isEdit">{{ $t('edit_printer') }}</h2>
      </template>
      <div>
        <div class="row" v-if="get_user.is_admin">
          <InputSelect
            class="m-b-40"
            :multiSelect=true
            :preselected="form.accessible_for_subaccounts"
            :label="$t('accessible_for_accounts')"
            @change="selectAccessibleSubaccount"
            :rules="{required: true}"
            :options="getAllowedSubaccounts" />
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('default_printer') }}</p>
                <span>{{ $t('Make printer default') }}</span>
              </div>
              <div>
                <Toggle id="makeDefaultPrinter" v-model="form.defaults" />
              </div>
            </div>
          </div>
        </div>
        <div class="separator medium"></div>
        <div class="row">
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="printersGroup"
              :text="$t('Label printer')"
              :checked="parseInt(form.type) === 1"
              @input="form.type = '1'"
              value="1"
              :rules="{required: true}"/>
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="printersGroup"
              :text="$t('Document printer')"
              :checked="parseInt(form.type) === 2"
              @input="form.type = '2'"
              value="2" />
          </div>
        </div>
        <div class="separator medium"></div>
        <div class="row m-b-20">
          <InputText
            class="col-xs-12 m-b-20"
            :label="$t('printer_name')"
            v-model="form.name"
            :rules="{required: true}"/>
          <div class="col-xs-6 m-b-20">
            <InputSelect
              :label="$t('driver')"
              v-model="form.driver_id"
              :options="selectOptions(get_printers.entity['drivers'])" />
          </div>
          <div class="col-xs-6 m-b-20">
            <InputSelect
              :label="$t('paper_size')"
              v-model="form.paper_size_id"
              :options="selectOptions(get_printers.entity['label_size'])" />
          </div>
          <InputText
            class="col-xs-6"
            label="WAN IP"
            v-model="form.ip"
            :rules="{required: true}"/>
          <InputText
            class="col-xs-6"
            label="Port"
            v-model="form.port"
            :rules="{required: true}"/>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('Test connection') }}</p>
                <span>{{ $t('Print a test page on your printer') }}</span>
              </div>
              <div>
                <Btn
                  class="brand"
                  :icon="{name: 'printer',size: '20'}"
                  :btnText="$t('test')"
                  @btnClick="testConnection" />
              </div>
            </div>
          </div>
        </div>
        <div class="separator medium" v-if="isEdit"></div>
        <div class="row">
          <div class="col-xs-12" v-if="isEdit">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('delete') }}</p>
                <span>{{ $t('Printer will be deleted') }}</span>
              </div>
              <div>
                <Toggle color="red" id="deletePrinter" v-model="deletePrinter" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import RadioButton from "@/components/elements/inputs/radio.vue";
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';

import InfoTextBox from '@/components/global/infoTextBox';
import formValidator from '@/mixins/formValidator';

export default {
  name: 'Printers',
  mixins: [formValidator],
  components: {
    Btn,
    Popup,
    InputText,
    RadioButton,
    InputSelect,
    Toggle,
    InfoTextBox,
  },
  data() {
    return {
      openPopup: false,
      isEdit: false,
      printerId: '',
      deletePrinter: false,
      updateList: 0,
      form: {
        type: '',
        name: '',
        ip: '',
        port: '',
        defaults: false,
        driver_id: '',
        paper_size_id: '',
        drivers: '',
        accessible_for_subaccounts: []
      },
      allowedSubaccounts: []
    };
  },
  computed: {
    ...mapGetters([
      'get_printers',
      'get_printer_by_id',
      'get_subaccounts',
      'get_user',
      'get_is_admin'
    ]),
    isPopupSubmitDisabled() {
      if(this.get_user.is_admin && this.form.accessible_for_subaccounts.length == 0) return true;
      const formWithValidators = [
        {
          formFeild:'name',
          value: this.form.name,
          validators:{required: true}
        },
        {
          formFeild:'ip',
          value: this.form.ip,
          validators:{required: true}
        },
        {
          formFeild:'port',
          value: this.form.port,
          validators:{required: true}
        },
      ]

      return this.validateInput(formWithValidators);
    },
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    }
  },
  created() {
    this.$store.dispatch('GET_PRINTERS');
  },
  methods: {
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: parseInt(property) });
      }
      return options;
    },
    selectAccessibleSubaccount(val) {
      if(val.length > 0){
        this.form.accessible_for_subaccounts = val;
      }
    },
    clearLocalFormData() {
      this.form = {
        type: '',
        name: '',
        ip: '',
        port: '',
        defaults: false,
        driver_id: '',
        paper_size_id: '',
        drivers: '',
        accessible_for_subaccounts: []
      };
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.printerId = '';
      this.clearLocalFormData();
    },
    submitForm() {
      const action = this.isEdit ? 'EDIT_PRINTER' : 'SET_PRINTER';

      this.form.accessible_for_subaccounts = this.form.accessible_for_subaccounts.filter((val) => this.get_user.accessible_subaccounts_array.indexOf(String(val)) > -1);

      this.$store.dispatch(`${action}`, {
        form: this.form,
        id: this.printerId || '',
      }).then(() => {
        this.$store.dispatch('GET_PRINTERS').then(() => {
          this.updateList++;
        });
        this.openPopup = false;
        this.clearLocalFormData();
      });
    },
    openNewPopup() {
      this.isEdit = false;
      this.togglePopup();
    },
    openEditPopup(id) {
      this.togglePopup();
      this.isEdit = true;
      this.printerId = id;
      this.form = {
        ...this.get_printer_by_id(id),
        accessible_for_subaccounts: this.get_printer_by_id(id).accessible_for_subaccounts
      };
    },
    testConnection() {
      this.$store.dispatch(`TEST_PRINTER`, {
        form: this.form,
      })
    },
    deletePrinterAction() {
      this.$store.dispatch('DELETE_PRINTER', this.printerId).then(() => {
        this.$store.dispatch('GET_PRINTERS').then(() => {
          this.updateList++;
        });
        this.deletePrinter = false;
        this.isEdit = false;
        this.togglePopup();
      });
    },
  },
};
</script>
